import { render, staticRenderFns } from "./MarketplaceCard.vue?vue&type=template&id=95d81292"
import script from "./MarketplaceCard.vue?vue&type=script&lang=ts"
export * from "./MarketplaceCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95d81292')) {
      api.createRecord('95d81292', component.options)
    } else {
      api.reload('95d81292', component.options)
    }
    module.hot.accept("./MarketplaceCard.vue?vue&type=template&id=95d81292", function () {
      api.rerender('95d81292', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/marketplace/MarketplaceCard.vue"
export default component.exports